import { type PDFDocumentProxy } from './pdfjs';

export function getPdfPageCount(pdf: PDFDocumentProxy): number {
  if (pdf !== null && typeof pdf === 'object') {
    return pdf.numPages;
  }

  return -1;
}
